import { escapeHtml } from '../ui.js'
import { apiConfigured, lookupTicket, pingHealth } from '../api.js'
import { isClientLoggedIn } from '../clientAuth.js'
import { bindClientLoginForm, clientLoginCardHtml } from '../clientLoginCard.js'

const TICKET_RE = /^(TCK|TK)[-–]?\s*[A-Z0-9]{4,}$/i
const CREATE_PREFILL_KEY = 'portal_create_prefill'

export function renderHome() {
  const welcome =
    'Red, WiFi, telefonía y videovigilancia de tu instalación. Si tienes contrato, entra a la derecha.'
  const newHref = isClientLoggedIn() ? '/mi-instalacion/nueva-incidencia' : '/nuevo'

  const rightPane = isClientLoggedIn()
    ? `
      <div class="home-login-card portal-card">
        <p class="portal-eyebrow">Sesión activa</p>
        <h2>Ya estás dentro</h2>
        <p class="portal-muted">Consulta la salud de tu instalación o abre un ticket autenticado.</p>
        <div class="home-login-actions">
          <a href="/mi-instalacion" data-link class="portal-btn portal-btn-primary portal-btn-block">Ir a mi portal</a>
          <a href="/mi-instalacion/nueva-incidencia" data-link class="portal-btn portal-btn-block">Crear ticket</a>
        </div>
      </div>`
    : clientLoginCardHtml({
        variant: 'home',
        showBack: false,
        showIcon: false,
        title: 'Clientes con contrato',
        lead: 'Entra a tu instalación: salud de red, WiFi, líneas y tickets.',
        submitLabel: 'Entrar a mi instalación',
        formId: 'home-client-login-form',
        msgId: 'home-client-login-msg',
        emailId: 'home-client-email',
        passwordId: 'home-client-password',
      })

  return `
    <div id="home-service-banner" class="portal-banner warn" hidden></div>

    <section class="home-split" aria-label="Inicio">
      <div class="home-intent">
        <p class="portal-eyebrow">Portal de soporte AGH</p>
        <h1>¿Qué necesitas hoy?</h1>
        <p class="portal-muted home-lead">${escapeHtml(welcome)}</p>
        <form id="home-intent-form" class="home-search" novalidate>
          <label class="portal-label" for="home_query">Ticket o problema</label>
          <div class="home-search-row">
            <input class="portal-input" id="home_query" name="query" autocomplete="off"
              placeholder="TCK-XXXXXX o describe el problema" />
            <button type="submit" class="portal-btn portal-btn-primary">Buscar</button>
          </div>
          <div class="portal-field home-email-field">
            <label class="portal-label" for="home_requester_email">Email (si buscas un ticket)</label>
            <input class="portal-input" type="email" id="home_requester_email" name="requester_email" autocomplete="email" />
          </div>
        </form>
        <p id="home-intent-msg" class="portal-muted portal-form-msg" role="status"></p>
        <div class="home-quick">
          <a href="${newHref}" data-link class="home-quick-chip">Abrir incidencia</a>
          <a href="/ia" data-link class="home-quick-chip">Hablar con IA</a>
        </div>
      </div>
      <div class="home-aside">${rightPane}</div>
    </section>

    <ul class="home-trust">
      <li><strong>12 años</strong><span>Acompañando empresas</span></li>
      <li><strong>Tickets</strong><span>Canal preferente de incidencias</span></li>
      <li><strong>Málaga · Costa del Sol</strong><span>Cobertura local</span></li>
    </ul>

    <div class="portal-grid home-paths">
      <a href="${isClientLoggedIn() ? '/mi-instalacion' : '/cliente'}" data-link class="portal-card portal-card-link home-path-card">
        <h2>Mi instalación</h2>
        <p class="portal-muted">Salud de red, dispositivos y servicios activos.</p>
      </a>
      <a href="${newHref}" data-link class="portal-card portal-card-link home-path-card">
        <h2>Nueva incidencia</h2>
        <p class="portal-muted">Describe el problema y nuestro equipo te ayudará.</p>
      </a>
      <a href="/ia" data-link class="portal-card portal-card-link home-path-card">
        <h2>Asistente IA</h2>
        <p class="portal-muted">Consulta rápida en redes y telecomunicaciones.</p>
      </a>
    </div>
  `
}

export function bindHome(root, { navigate }) {
  const banner = root.querySelector('#home-service-banner')
  if (apiConfigured()) {
    pingHealth().then((r) => {
      if (!r.ok && banner) {
        banner.hidden = false
        banner.textContent =
          'El servicio de soporte no está disponible temporalmente. Inténtalo de nuevo en unos minutos o contacta por teléfono o email.'
      }
    })
  } else if (banner) {
    banner.hidden = false
    banner.textContent =
      'El servicio de soporte no está disponible temporalmente. Contacta por teléfono o email (ver pie de página).'
  }

  if (!isClientLoggedIn()) {
    bindClientLoginForm(root, {
      navigate,
      formId: 'home-client-login-form',
      msgId: 'home-client-login-msg',
    })
  }

  const form = root.querySelector('#home-intent-form')
  const msg = root.querySelector('#home-intent-msg')
  form?.addEventListener('submit', async (ev) => {
    ev.preventDefault()
    const query = String(form.query.value || '').trim()
    const email = String(form.requester_email.value || '').trim()
    msg.classList.remove('is-error')
    msg.textContent = ''

    if (!query) {
      msg.textContent = 'Escribe un número de ticket o describe el problema.'
      msg.classList.add('is-error')
      return
    }

    if (TICKET_RE.test(query.replace(/\s+/g, ''))) {
      if (!email) {
        msg.textContent = 'Para buscar un ticket indica también el email.'
        msg.classList.add('is-error')
        form.requester_email.focus()
        return
      }
      if (!apiConfigured()) {
        msg.textContent = 'Servicio no disponible. Usa el teléfono o email del pie de página.'
        msg.classList.add('is-error')
        return
      }
      msg.textContent = 'Buscando…'
      try {
        const data = await lookupTicket(query, email)
        navigate(data.portal_path || `/t/${data.access_token}`)
      } catch (e) {
        msg.textContent = e.message || 'No encontrado'
        msg.classList.add('is-error')
      }
      return
    }

    try {
      sessionStorage.setItem(
        CREATE_PREFILL_KEY,
        JSON.stringify({ description: query, subject: query.slice(0, 80) })
      )
    } catch (_) {}
    navigate(isClientLoggedIn() ? '/mi-instalacion/nueva-incidencia' : '/nuevo')
  })
}
